import type { Metadata } from "next";
import { StaticPage } from "@/components/static-page";

export const metadata: Metadata = {
  title: "Giới thiệu",
  description:
    "Finzone Network — trang tin tài chính kinh tế cho nhà đầu tư Việt Nam. Crypto, chứng khoán, vàng, forex, phân tích chuyên sâu.",
  alternates: { canonical: "/gioi-thieu" },
};

export default function Page() {
  return (
    <StaticPage
      title="Về Finzone Network"
      eyebrow="Giới thiệu"
      description="Trang tin tài chính kinh tế độc lập cho nhà đầu tư Việt Nam, ra đời với một mục tiêu duy nhất: giúp người đọc đưa ra quyết định tài chính tỉnh táo hơn."
    >
      <h2>Chúng tôi viết về gì</h2>
      <p>
        Finzone tập trung vào bốn nhóm tài sản chính có ý nghĩa với nhà đầu tư Việt Nam:
        <strong> Crypto</strong> (Bitcoin, Ethereum, altcoin, on-chain), <strong>Chứng khoán</strong>
        {" "}(VN-Index, Phố Wall, doanh nghiệp niêm yết), <strong>Vàng</strong>
        {" "}(SJC, vàng nhẫn, vàng thế giới) và <strong>Forex</strong>
        {" "}(USD/VND, dầu, ngoại hối). Mỗi bài viết phải trả lời được câu hỏi
        “điều gì vừa xảy ra, tại sao quan trọng, và nó tác động đến danh mục thế nào”.
      </p>

      <h2>Đội ngũ biên tập</h2>
      <p>
        <strong>Finzone Editorial Team</strong> là một nhóm nhỏ những người làm tài chính,
        công nghệ và báo chí. Chúng tôi không phải sàn giao dịch, không phải quỹ đầu tư,
        không phải nhà môi giới — đó là lý do chúng tôi có thể nhìn thẳng vào dữ liệu mà
        không bị áp lực bán hàng.
      </p>

      <h2>Cam kết</h2>
      <ul>
        <li>Viết bằng dữ liệu, không viết bằng cảm tính</li>
        <li>Chỉ ra rủi ro song song với cơ hội</li>
        <li>Quảng cáo (nếu có) được gắn nhãn rõ ràng, không trá hình thành nội dung biên tập</li>
        <li>Sửa lỗi công khai khi sai và ghi rõ thời điểm cập nhật</li>
      </ul>

      <h2>Lịch xuất bản</h2>
      <p>
        Tin nóng được cập nhật liên tục trong giờ giao dịch. Bản tin tóm tắt thị trường được gửi
        qua email, Telegram và Zalo group lúc 7 giờ sáng các ngày làm việc. Bài phân tích chuyên
        sâu được xuất bản 2–3 lần mỗi tuần, vào buổi tối.
      </p>

      <h2>Liên hệ</h2>
      <p>
        Mọi phản hồi, đính chính, đề xuất hợp tác xin gửi về <a href="/lien-he">trang Liên hệ</a>.
      </p>
    </StaticPage>
  );
}
